import type { SdkConfigureStore } from "@payping/redux";
import { SdkStoreStates } from "@payping/redux/reducers";
import * as Sentry from "@sentry/react";

import loginRedirect, { LoginRedirectState } from "@/redux/reducers/loginRedirect";
import dashboard, { DashboardReduxReducerState } from "@/redux/reducers/dashboard";
import dashboardPersist, { DashboardPersistReduxState } from "@/redux/reducers/dashboardPersist";

import persistConfig from "./persistConfig";

export interface AppStoreStates extends SdkStoreStates {
  loginRedirect: LoginRedirectState;
  dashboard: DashboardReduxReducerState;
  dashboardPersist: DashboardPersistReduxState;
}

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const appReducers = {
  loginRedirect,
  dashboard,
  dashboardPersist,
};

export const reduxConfig: SdkConfigureStore = {
  appEnhancers: [sentryReduxEnhancer],
  appPersistConfig: persistConfig,
  // @ts-expect-error wrong type
  appReducers,
};
